export enum RequestType {
    GetProperty = 'getProperty',
    SetProperty = 'setProperty',
    Invoke = 'invoke',
}
